"use strict";
var Observable_1 = require("../../Observable");
var bufferTime_1 = require("../../operator/bufferTime");
Observable_1.Observable.prototype.bufferTime = bufferTime_1.bufferTime;
//# sourceMappingURL=bufferTime.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/bufferTime.js
 ** module id = 265
 ** module chunks = 1
 **/